
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire0c01"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire0c01"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("ekglj", function(module, exports) {

$parcel$export(module.exports, "automate", () => $a6df9c40ba402dc9$export$ff58b0f795d33274);
$parcel$export(module.exports, "cacheClear", () => $a6df9c40ba402dc9$export$43b45930aa9b617e);
$parcel$export(module.exports, "cachePost", () => $a6df9c40ba402dc9$export$8c41aa1e5d276986);
$parcel$export(module.exports, "trackingAPI", () => $a6df9c40ba402dc9$export$fb5ee0767eef1668);
$parcel$export(module.exports, "sleep", () => $a6df9c40ba402dc9$export$e772c8ff12451969);
$parcel$export(module.exports, "pdfReader", () => $a6df9c40ba402dc9$export$e20914da38da725e);
$parcel$export(module.exports, "iFramer", () => $a6df9c40ba402dc9$export$653e1027d7e97690);
$parcel$export(module.exports, "date", () => $a6df9c40ba402dc9$export$324d90190a8b822a);
$parcel$export(module.exports, "help", () => $a6df9c40ba402dc9$export$34512e3b2db52a4e);
$parcel$export(module.exports, "transition", () => $a6df9c40ba402dc9$export$66bb15e2994e6a26);
$parcel$export(module.exports, "uiBuilder", () => $a6df9c40ba402dc9$export$bee0cbf01635c73);
$parcel$export(module.exports, "prepareHTML", () => (parcelRequire("6tULh")).prepareHTML);
/***********************************************************************
 utils contains useful utility functions that are commonly used by 
 this MPA
************************************************************************/ 
var $6KOho = parcelRequire("6KOho");

var $59kwG = parcelRequire("59kwG");

var $fmRoT = parcelRequire("fmRoT");

var $6tULh = parcelRequire("6tULh");

var $4l797 = parcelRequire("4l797");

var $fZ5A9 = parcelRequire("fZ5A9");
/**
 * function automates hidden input to forms that it is imported to, including the on click return event
 * @param {object} account - the account for the API call
 * @param {object} elementID - contains the div ID of the form input
 * @param {object} value - contains values to be inserted to the form input
 * @param {string} form - the form for the API call
 * @param {string} myReturn - the page that the return button will go to on click
 */ function $a6df9c40ba402dc9$export$ff58b0f795d33274(account, elementID, value, form, returnPage) {
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))('#interface').html(`${(0, $4l797.returnButton)()}`);
    if (form == "Social media handles" || form == "Refund") (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(elementID.institution).val(value.institution);
    else {
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(elementID.institution).empty();
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(elementID.institution).append(`
            <option value="${value.institution}" selected>${value.institution}</option>
        `);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(elementID.program).val(value.program);
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(elementID.term).val(value.term);
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(elementID.pid).val(value.pid);
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))('#return').on('click', ()=>{
        $a6df9c40ba402dc9$export$43b45930aa9b617e(account), window.location.href = returnPage;
    });
    console.log(`institution: ${(0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(elementID.institution).val()}\nprogram: ${(0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(elementID.program).val()}\nterm: ${(0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(elementID.term).val()}\nppid: ${(0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(elementID.pid).val()}\n`);
    $a6df9c40ba402dc9$export$8c41aa1e5d276986(account, form);
}
/**
 * Utility API function for the mapping of api routes for tracked items in v1/Participant Model {@link https://github.com/chizuo/evp-portal-api/blob/main/docs/v1/participant.md}
 * @param {string} item - the item for the API call
 * @param {object} account - the account for the API call
 * @param {number} retries - the amount of times an API attempt had to be made
 */ async function $a6df9c40ba402dc9$export$fb5ee0767eef1668(item, account, retries = 0) {
    try {
        const response = await (0, $fmRoT.default).put(`${(0, $fZ5A9.domain)}/${(0, $fZ5A9.route).get(item)}`, {
            uid: account.uid,
            program: account.program,
            semester: account.semester,
            year: account.year
        });
        let isGuide = item.includes('Guide');
        let isExample = item.includes('example');
        if ((0, $fZ5A9.step).get(item) === 'step1') {
            item = isGuide ? 'Guide' : item;
            account.tracked.step1[item]++;
        } else if ((0, $fZ5A9.step).get(item) === 'step2') {
            item = isGuide ? 'Guide' : item;
            item = isExample ? 'Examples' : item;
            account.tracked.step2[item]++;
        } else if ((0, $fZ5A9.step).get(item) === 'step3') {
            item = isGuide ? 'Guide' : item;
            account.tracked.step3[item]++;
        } else if ((0, $fZ5A9.step).get(item) === 'step4') {
            item = isGuide ? 'Guide' : item;
            item = isExample ? 'Examples' : item;
            account.tracked.step4[item]++;
        } else if ((0, $fZ5A9.step).get(item) === 'budgetManagement') {
            item = isGuide ? 'Guide' : item;
            account.tracked.budgetManagement[item]++;
        } else console.error(`Section for ${item} does not exist in the configuration`);
        console.log(JSON.parse(JSON.stringify(account)));
        sessionStorage.setItem('evp_participant', JSON.stringify(account));
    } catch (e) {
        ++retries;
        console.error(e.message);
        $a6df9c40ba402dc9$export$e772c8ff12451969(retries * 250).then(()=>{
            if (retries < 5) $a6df9c40ba402dc9$export$fb5ee0767eef1668(item, account, retries);
        });
    }
}
/**
 * Creates the PDF reader interface for the portal
 * @param {string} path - path of the PDF
 * @param {function} prevUi - function that loads the previous interface
 */ function $a6df9c40ba402dc9$export$e20914da38da725e(path, prevUi) {
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))('#interface').html(`
        ${(0, $4l797.returnButton)()}
        ${(0, $4l797.pdf)(path)}
    `);
    (0, $4l797.previous)(prevUi);
}
/**
 * Creates the YouTube video player interface for the portal
 * @param {string} url - url of the video
 * @param {function} prev - function that loads the previous interface
 */ function $a6df9c40ba402dc9$var$youtubePlayer(url, prev) {
    function youtubeEmbedder(url) {
        if (url.includes("youtube.com/embed/")) return url;
        const regex = /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
        const match = url.match(regex);
        if (match && match[1]) {
            const videoId = match[1];
            const embedUrl = `https://www.youtube.com/embed/${videoId}?si=6Nu7nYFFGI8CCarh`;
            return embedUrl;
        } else // Return null or an appropriate message if the URL is invalid
        return null;
    }
    const screenWidth = (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(window).width();
    const screenHeight = (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(window).height();
    // Calculate the dimensions for the iframe
    const iframeWidth = screenWidth * 0.8; // 80% of screen width
    const iframeHeight = screenHeight * 0.5; // 50% of screen height
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))('#interface').html(`
        ${(0, $4l797.returnButton)()}
        <center class="m-3">
            <iframe width="${iframeWidth}" height="${iframeHeight}" src="${youtubeEmbedder(url)}" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
        <center>
    `);
    (0, $4l797.previous)(prev);
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))('html, body').animate({
        scrollTop: (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#interface").offset().top
    }, 500);
// sleep(15 * 1000).then(() => trackingAPI('Kickoff material')); // TODO: this web request fails. Should the item be hard-coded?
}
/**
 * Utility function to dynamically set the iframe based on the window.
 * @param {integer} h - integer representing a percentage to be set for height based on window size, defaults to 80.
 * @param {integer} w - integer representing a percentage to be set for width based on window size, defaults to 80.
 * @returns {Object} returns the object { iframeHeight, iframeWidth }
 */ function $a6df9c40ba402dc9$export$653e1027d7e97690(h = 80, w = 80) {
    const height = h / 100;
    const width = w / 100;
    // Get the new screen width and height
    const screenWidth = (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(window).width();
    const screenHeight = (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(window).height();
    // Calculate the new dimensions for the iframe
    const iframeWidth = screenWidth * width;
    const iframeHeight = screenHeight * height;
    // Set the new dimensions
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("iframe").css({
        "width": iframeWidth,
        "height": iframeHeight
    });
    return {
        iframeHeight: iframeHeight,
        iframeWidth: iframeWidth
    };
}
/**
 * Returns the full name of the month.
 * @param {integer} m - number representing the month, starting at 0 as January to 11 as December.
 * @param {integer} d - number representing the month, starting at 0 as January to 11 as December.
 * @param {integer} y - number representing the month, starting at 0 as January to 11 as December.
 * @returns {string} formatted date as a string based in parameters provided, e.g. January 1, 2000, returns an empty string if no parameters are provided
 */ function $a6df9c40ba402dc9$export$324d90190a8b822a(m = -1, y = -1, d = 0) {
    const d30 = new Set([
        3,
        5,
        8,
        10
    ]);
    let md = m >= 0 && m <= 11 ? (0, $fZ5A9.month).get(m) : ''; // validate m & gets month of m
    if (d && md.length) {
        if (m === 1 && d > 28) d = 28;
        else if (d30.has(m) && d > 30) d = 30;
        else if (d > 31) d = 31;
        md += ' ' + d; // adds the day
    }
    let format = md.length && d ? ', ' : ' '; // adds comma if m,d are provided.
    if (y) md += format + y;
    return md;
}
/**
 * Function that pauses the thread for the indicated length, in milliseconds, that is passed in
 * @param {integer} ms - length of time, in milliseconds, that this function should cause a thread to sleep.
 * @returns {Promise} resolves after the parameter ms time
 */ function $a6df9c40ba402dc9$export$e772c8ff12451969(ms = 250) {
    return new Promise((resolve)=>setTimeout(resolve, ms));
}
/**
 * Function that captures the module where the help icon was clicked to launch the help
 * form application and adds the step and section to the account object to store in
 * sessionStorage for the help form application to retrieve.
 * @param {string} step
 * @param {string} section
 * @param {object} account
 */ function $a6df9c40ba402dc9$export$34512e3b2db52a4e(step, section, account) {
    account.step = step;
    account.section = section;
    sessionStorage.setItem('evp_participant', JSON.stringify(account));
    $a6df9c40ba402dc9$export$e772c8ff12451969(1000).then(()=>window.location.href = 'help_request');
}
/**
 * Function that will make the interface run a transition animation to a new DOM element or new document
 * @param {function} next - callback function that either changes the document or changes the #interface element.
 */ function $a6df9c40ba402dc9$export$66bb15e2994e6a26(next) {
    let animationCount = (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))('.right').length + (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))('.left').length + (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))('.zoom').length;
    if (animationCount === 0) {
        next();
        return;
    }
    function animationEnded() {
        animationCount--;
        if (animationCount === 0) next();
        else if (animationCount < 0) throw new Error('animationCount < 0');
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))('.right').each(function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(this).removeClass('animate__animated animate__backInRight animate__backInLeft');
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(this).addClass('animate__animated animate__backOutRight');
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(this).one('animationend', animationEnded);
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))('.left').each(function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(this).removeClass('animate__animated animate__backInLeft');
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(this).addClass('animate__animated animate__backOutLeft');
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(this).one('animationend', animationEnded);
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))('.zoom').each(function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(this).removeClass('animate__animated animate__zoomIn');
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(this).addClass('animate__animated animate__zoomOut');
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(this).one('animationend', animationEnded);
    });
}
function $a6df9c40ba402dc9$export$8c41aa1e5d276986(account, form) {
    account.post = form;
    console.log("cached account: ", account);
    sessionStorage.setItem('evp_participant', JSON.stringify(account));
}
function $a6df9c40ba402dc9$export$43b45930aa9b617e(account) {
    if (account.post) delete account.post;
    if (account.receipt) delete account.receipt;
    if (account.section) delete account.section;
    sessionStorage.setItem('evp_participant', JSON.stringify(account));
}
/**
 * getRowWidth determines the maximum number of buttons that should be on each row of the
 * UI.
 * @param {Element[]} elements
 * @returns {number}
 */ function $a6df9c40ba402dc9$var$getRowWidth(elements) {
    let elementCount = 0;
    // count only unhidden elements
    for (const el of elements)if (!el.hidden) elementCount++;
    if (elementCount <= 2) return 2;
    else if (elementCount % 4 === 0) return 4;
    else return 3;
}
/**
 * @typedef {object} Element
 * @property {'href'|'openUri'|'menu'|'frame'|'youtube'|'pdf'|'help'} type
 * @property {string} title
 * @property {boolean|undefined} comingSoon
 * @property {boolean|undefined} hidden
 * @property {string|undefined} iconPath - absolute file path.
 * @property {string|undefined} uri - required if type is href, openUri, menu, frame,
 * youtube, pdf, or help.
 * @property {string|undefined} trackingName
 * @property {object|undefined} button - only available when type is frame.
 * @property {string} button.title
 * @property {string} button.uri - the URI to set location.href to on button click.
 * @property {
 *   'primary'|'secondary'|'success'|'danger'|'warning'|'info'|'light'|'dark'|'link' }
 *   button.variant - https://getbootstrap.com/docs/5.3/components/buttons/#variants
 * @property {string|undefined} step - required if type is help.
 * @property {string|undefined} section - required if type is help.
 */ /**
 * @typedef {object} UiData
 * @property {string} path - the folder path for resources of UI data.
 * @property {Element[]} elements
 */ /**
 * uiBuilder creates a page of buttons and replaces the interface.
 * @param {UiData} uiData
 * @param {function(): void} ui
 * @param {function(): void} prevUi
 * @param {any} account
 * @param {object} menus
 * @returns {void}
 */ function $a6df9c40ba402dc9$export$bee0cbf01635c73(uiData, ui, prevUi, account, menus) {
    /** @type {Element[]} */ const elements = uiData.elements;
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))('#interface').html((0, $4l797.returnButton)());
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))('#return').on('click', prevUi);
    const perRow = $a6df9c40ba402dc9$var$getRowWidth(elements);
    let buttonClass = 'g-0 m-2 animate__animated animate__backInLeft icon-15 glow-button left';
    if (perRow === 4) buttonClass += ' col-sm-2';
    else if (perRow === 3) buttonClass += ' col-sm-3';
    else buttonClass += ' col-sm-4';
    let i = 0;
    while(i < elements.length){
        const rowId = 'row-with-element-' + i;
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))('#interface').append(`<div id="${rowId}" class="row mt-1"></div>`);
        for(let col = 0; col < perRow && i < elements.length; col++, i++){
            if (elements[i].hidden) {
                col--;
                continue;
            }
            let buttonStyle = `font-family: ${(0, $fZ5A9.buttonFontFamily)};`;
            let buttonIconSrc = '';
            if ((0, $fZ5A9.iconPreference) && (0, $fZ5A9.buttonIcons).length > 0) {
                // use a PNG
                buttonIconSrc = (0, $fZ5A9.buttonIcons)[0];
                (0, $fZ5A9.buttonIcons).push((0, $fZ5A9.buttonIcons).shift());
            } else {
                // use a color
                buttonStyle += `background-color: ${(0, $fZ5A9.buttonColors)[0]};`;
                (0, $fZ5A9.buttonColors).push((0, $fZ5A9.buttonColors).shift());
            }
            $a6df9c40ba402dc9$var$buttonBuilder(elements[i], perRow, buttonClass, buttonStyle, buttonIconSrc, rowId, uiData.path, ui, account, menus);
        }
    }
}
/**
 * buttonBuilder creates a UI button and appends it to a row in the interface.
 * @param {Element} element
 * @param {number} perRow
 * @param {string} buttonClass
 * @param {string} buttonStyle
 * @param {any} buttonIconSrc
 * @param {string} rowId
 * @param {string} uiDataPath
 * @param {function(): void} ui
 * @param {any} account
 * @param {object} menus
 * @returns {void}
 */ function $a6df9c40ba402dc9$var$buttonBuilder(element, perRow, buttonClass, buttonStyle, buttonIconSrc, rowId, uiDataPath, ui, account, menus) {
    let title = element.title;
    if (element.comingSoon) {
        buttonClass += ' dark-50';
        title += ' coming soon';
    }
    const buttonId = $a6df9c40ba402dc9$var$createHtmlElementId(title);
    const fontSize = $a6df9c40ba402dc9$var$getFontSize(title, perRow);
    const buttonTitleStyle = `
        font-size: ${fontSize}%;
        width: ${(0, $fZ5A9.buttonTitleWidth)}%;
    `;
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))('#' + rowId).append(`
        <div id="${buttonId}" class="${buttonClass}" style="${buttonStyle}">
            <div class="square-container-normal">
                <div class="title-overlay text-center" style="${buttonTitleStyle}">
                    ${title}
                </div>
            </div>
        </div>
    `);
    if (buttonIconSrc) (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))('#' + buttonId + ' div').prepend(`
            <img src=${buttonIconSrc} class="fill icon-15" />
        `);
    if (element.comingSoon) return;
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))('#' + buttonId).on('click', ()=>{
        if (element.trackingName) $a6df9c40ba402dc9$export$fb5ee0767eef1668(element.trackingName, account);
        switch(element.type){
            case 'href':
                $a6df9c40ba402dc9$export$66bb15e2994e6a26(()=>window.location.href = element.uri);
                break;
            case 'openUri':
                window.open(element.uri);
                break;
            case 'youtube':
                $a6df9c40ba402dc9$var$youtubePlayer(element.uri, ui);
                break;
            case 'menu':
                $a6df9c40ba402dc9$var$menuBuilder(element, buttonId, ui, account, menus);
                break;
            case 'frame':
                $a6df9c40ba402dc9$var$frameBuilder(element, ui);
                break;
            case 'pdf':
                $a6df9c40ba402dc9$export$66bb15e2994e6a26(()=>{
                    const pdfPath = (0, (/*@__PURE__*/$parcel$interopDefault($59kwG))).join(uiDataPath, element.uri);
                    $a6df9c40ba402dc9$export$e20914da38da725e(pdfPath, ui);
                });
                break;
            case 'help':
                $a6df9c40ba402dc9$export$66bb15e2994e6a26(()=>$a6df9c40ba402dc9$export$34512e3b2db52a4e(element.step, element.section, account));
                break;
            default:
                throw new Error('Unknown element type: ' + element.type);
        }
    });
}
/**
 * menuBuilder attempts to load a JSON file and replaces the interface with a new menu
 * created from the JSON file.
 * @param {Element} element
 * @param {string} buttonId
 * @param {function(): void} prev
 * @param {any} account
 * @param {object} menus
 * @returns {boolean} - whether successful.
 */ function $a6df9c40ba402dc9$var$menuBuilder(element, buttonId, prev, account, menus) {
    function menuUi() {
        /** @type {UiData} */ const uiData = menus[element.uri];
        if (uiData === undefined) {
            console.error(`uiData is undefined because "menus" does not contain "${element.uri}"`);
            $a6df9c40ba402dc9$var$errDisableButton(buttonId);
            return false;
        }
        $a6df9c40ba402dc9$export$66bb15e2994e6a26(()=>$a6df9c40ba402dc9$export$bee0cbf01635c73(uiData, menuUi, prev, account, menus));
    }
    try {
        menuUi();
    } catch (err) {
        console.error('menuUi: ' + err);
        $a6df9c40ba402dc9$var$errDisableButton(buttonId);
        return false;
    }
    return true;
}
/**
 * frameBuilder replaces the interface with an iframe.
 * @param {Element} element
 * @param {function(): void} prev
 */ function $a6df9c40ba402dc9$var$frameBuilder(element, prev) {
    const { iframeHeight: iframeHeight, iframeWidth: iframeWidth } = $a6df9c40ba402dc9$export$653e1027d7e97690();
    console.log(`height:${iframeHeight} & width:${iframeWidth}`);
    const buttonGroupId = $a6df9c40ba402dc9$var$createHtmlElementId(element.title) + '-button-group';
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))('#interface').html(`
        <center class="animate__animated animate__zoomIn">
            <div id="${buttonGroupId}" class="btn-group w-25 m-2" role="group" aria-label="mini-menu">
                <button type="button" id="return" class="btn btn-primary w-25">
                    Return
                </button>
            </div>
            <iframe src="${element.uri}" width="${iframeWidth}" height="${iframeHeight}" frameborder="1">
            </iframe>
        </center>
    `);
    if (element.button) {
        const buttonId = $a6df9c40ba402dc9$var$createHtmlElementId(element.title) + '-button';
        const title = element.button.title || 'click';
        const variant = element.button.variant || 'secondary';
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))('#' + buttonGroupId).append(`
            <button type="button" id="${buttonId}" class="btn btn-${variant} w-25">
                ${title}
            </button>
        `);
        if (element.button.uri) (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))('#' + buttonId).on('click', ()=>window.location.href = element.button.uri);
    }
    (0, $4l797.previous)(prev);
}
/**
 * createHtmlElementId replaces certain characters with dashes and may prepend a letter
 * to create a valid HTML element ID compatible with jQuery.
 * @param {string} str
 * @returns {string}
 */ function $a6df9c40ba402dc9$var$createHtmlElementId(str) {
    return str.replaceAll('&', 'and').replaceAll(/[ \.\/\:\[\]\,\=\@\'\"\?~!\$%^\*\(\)\+;><\\\{\}|`#]/g, '-').replace(/^([^a-zA-Z].*)/, 'a$1') // must start with a letter
    ;
}
/**
 * getFontSize determines the percentage font size to use depending on the title and the
 * number of buttons per row.
 * @param {string} title
 * @param {number} perRow
 * @returns {number}
 */ function $a6df9c40ba402dc9$var$getFontSize(title, perRow) {
    if (perRow === 2) return $a6df9c40ba402dc9$var$_getFontSize(title, (0, $fZ5A9.twoPerRowStr), (0, $fZ5A9.twoPerRowSubstr));
    else if (perRow === 3) return $a6df9c40ba402dc9$var$_getFontSize(title, (0, $fZ5A9.threePerRowStr), (0, $fZ5A9.threePerRowSubstr));
    else return $a6df9c40ba402dc9$var$_getFontSize(title, (0, $fZ5A9.fourPerRowStr), (0, $fZ5A9.fourPerRowSubstr));
}
/**
 * @param {string} title
 * @param {Map<number, number>} perRowStrMap
 * @param {Map<number, number>} perRowSubstrMap
 * @returns {number}
 */ function $a6df9c40ba402dc9$var$_getFontSize(title, perRowStrMap, perRowSubstrMap) {
    let strValue = undefined;
    for (const [key, value] of perRowStrMap)if (title.length <= key) {
        strValue = value;
        break;
    }
    let longestWordLen = 0;
    const words = title.split(' ');
    for(let i = 0; i < words.length; i++){
        const len = words[i].length;
        if (len > longestWordLen) longestWordLen = len;
    }
    let substrValue = undefined;
    for (const [key, value] of perRowSubstrMap)if (longestWordLen <= key) {
        substrValue = value;
        break;
    }
    if (strValue === undefined && substrValue === undefined) return 100;
    else if (strValue === undefined) return substrValue;
    else if (substrValue === undefined) return strValue;
    else return strValue < substrValue ? strValue : substrValue;
}
/**
 * errDisableButton disables a button, makes it darker, and replaces its title with
 * "Error".
 * @param {string} buttonId
 * @returns {void}
 */ function $a6df9c40ba402dc9$var$errDisableButton(buttonId) {
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))('#' + buttonId).addClass('dark-50').html(`
            <div class="square-container-normal">
                <div class="overlay-text text-center display-4">
                    Error
                </div>
            </div>`).prop('onclick', null).off('click');
}

});
parcelRegister("59kwG", function(module, exports) {
// 'path' module extracted from Node.js v8.11.1 (only the posix part)
// transplited with Babel
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $hPtJY = parcelRequire("hPtJY");
'use strict';
function $3bfdb7183e8721d6$var$assertPath(path) {
    if (typeof path !== 'string') throw new TypeError('Path must be a string. Received ' + JSON.stringify(path));
}
// Resolves . and .. elements in a path with directory names
function $3bfdb7183e8721d6$var$normalizeStringPosix(path, allowAboveRoot) {
    var res = '';
    var lastSegmentLength = 0;
    var lastSlash = -1;
    var dots = 0;
    var code;
    for(var i = 0; i <= path.length; ++i){
        if (i < path.length) code = path.charCodeAt(i);
        else if (code === 47 /*/*/ ) break;
        else code = 47 /*/*/ ;
        if (code === 47 /*/*/ ) {
            if (lastSlash === i - 1 || dots === 1) ;
            else if (lastSlash !== i - 1 && dots === 2) {
                if (res.length < 2 || lastSegmentLength !== 2 || res.charCodeAt(res.length - 1) !== 46 /*.*/  || res.charCodeAt(res.length - 2) !== 46 /*.*/ ) {
                    if (res.length > 2) {
                        var lastSlashIndex = res.lastIndexOf('/');
                        if (lastSlashIndex !== res.length - 1) {
                            if (lastSlashIndex === -1) {
                                res = '';
                                lastSegmentLength = 0;
                            } else {
                                res = res.slice(0, lastSlashIndex);
                                lastSegmentLength = res.length - 1 - res.lastIndexOf('/');
                            }
                            lastSlash = i;
                            dots = 0;
                            continue;
                        }
                    } else if (res.length === 2 || res.length === 1) {
                        res = '';
                        lastSegmentLength = 0;
                        lastSlash = i;
                        dots = 0;
                        continue;
                    }
                }
                if (allowAboveRoot) {
                    if (res.length > 0) res += '/..';
                    else res = '..';
                    lastSegmentLength = 2;
                }
            } else {
                if (res.length > 0) res += '/' + path.slice(lastSlash + 1, i);
                else res = path.slice(lastSlash + 1, i);
                lastSegmentLength = i - lastSlash - 1;
            }
            lastSlash = i;
            dots = 0;
        } else if (code === 46 /*.*/  && dots !== -1) ++dots;
        else dots = -1;
    }
    return res;
}
function $3bfdb7183e8721d6$var$_format(sep, pathObject) {
    var dir = pathObject.dir || pathObject.root;
    var base = pathObject.base || (pathObject.name || '') + (pathObject.ext || '');
    if (!dir) return base;
    if (dir === pathObject.root) return dir + base;
    return dir + sep + base;
}
var $3bfdb7183e8721d6$var$posix = {
    // path.resolve([from ...], to)
    resolve: function resolve() {
        var resolvedPath = '';
        var resolvedAbsolute = false;
        var cwd;
        for(var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--){
            var path;
            if (i >= 0) path = arguments[i];
            else {
                if (cwd === undefined) cwd = $hPtJY.cwd();
                path = cwd;
            }
            $3bfdb7183e8721d6$var$assertPath(path);
            // Skip empty entries
            if (path.length === 0) continue;
            resolvedPath = path + '/' + resolvedPath;
            resolvedAbsolute = path.charCodeAt(0) === 47 /*/*/ ;
        }
        // At this point the path should be resolved to a full absolute path, but
        // handle relative paths to be safe (might happen when process.cwd() fails)
        // Normalize the path
        resolvedPath = $3bfdb7183e8721d6$var$normalizeStringPosix(resolvedPath, !resolvedAbsolute);
        if (resolvedAbsolute) {
            if (resolvedPath.length > 0) return '/' + resolvedPath;
            else return '/';
        } else if (resolvedPath.length > 0) return resolvedPath;
        else return '.';
    },
    normalize: function normalize(path) {
        $3bfdb7183e8721d6$var$assertPath(path);
        if (path.length === 0) return '.';
        var isAbsolute = path.charCodeAt(0) === 47 /*/*/ ;
        var trailingSeparator = path.charCodeAt(path.length - 1) === 47 /*/*/ ;
        // Normalize the path
        path = $3bfdb7183e8721d6$var$normalizeStringPosix(path, !isAbsolute);
        if (path.length === 0 && !isAbsolute) path = '.';
        if (path.length > 0 && trailingSeparator) path += '/';
        if (isAbsolute) return '/' + path;
        return path;
    },
    isAbsolute: function isAbsolute(path) {
        $3bfdb7183e8721d6$var$assertPath(path);
        return path.length > 0 && path.charCodeAt(0) === 47 /*/*/ ;
    },
    join: function join() {
        if (arguments.length === 0) return '.';
        var joined;
        for(var i = 0; i < arguments.length; ++i){
            var arg = arguments[i];
            $3bfdb7183e8721d6$var$assertPath(arg);
            if (arg.length > 0) {
                if (joined === undefined) joined = arg;
                else joined += '/' + arg;
            }
        }
        if (joined === undefined) return '.';
        return $3bfdb7183e8721d6$var$posix.normalize(joined);
    },
    relative: function relative(from, to) {
        $3bfdb7183e8721d6$var$assertPath(from);
        $3bfdb7183e8721d6$var$assertPath(to);
        if (from === to) return '';
        from = $3bfdb7183e8721d6$var$posix.resolve(from);
        to = $3bfdb7183e8721d6$var$posix.resolve(to);
        if (from === to) return '';
        // Trim any leading backslashes
        var fromStart = 1;
        for(; fromStart < from.length; ++fromStart){
            if (from.charCodeAt(fromStart) !== 47 /*/*/ ) break;
        }
        var fromEnd = from.length;
        var fromLen = fromEnd - fromStart;
        // Trim any leading backslashes
        var toStart = 1;
        for(; toStart < to.length; ++toStart){
            if (to.charCodeAt(toStart) !== 47 /*/*/ ) break;
        }
        var toEnd = to.length;
        var toLen = toEnd - toStart;
        // Compare paths to find the longest common path from root
        var length = fromLen < toLen ? fromLen : toLen;
        var lastCommonSep = -1;
        var i = 0;
        for(; i <= length; ++i){
            if (i === length) {
                if (toLen > length) {
                    if (to.charCodeAt(toStart + i) === 47 /*/*/ ) // We get here if `from` is the exact base path for `to`.
                    // For example: from='/foo/bar'; to='/foo/bar/baz'
                    return to.slice(toStart + i + 1);
                    else if (i === 0) // We get here if `from` is the root
                    // For example: from='/'; to='/foo'
                    return to.slice(toStart + i);
                } else if (fromLen > length) {
                    if (from.charCodeAt(fromStart + i) === 47 /*/*/ ) // We get here if `to` is the exact base path for `from`.
                    // For example: from='/foo/bar/baz'; to='/foo/bar'
                    lastCommonSep = i;
                    else if (i === 0) // We get here if `to` is the root.
                    // For example: from='/foo'; to='/'
                    lastCommonSep = 0;
                }
                break;
            }
            var fromCode = from.charCodeAt(fromStart + i);
            var toCode = to.charCodeAt(toStart + i);
            if (fromCode !== toCode) break;
            else if (fromCode === 47 /*/*/ ) lastCommonSep = i;
        }
        var out = '';
        // Generate the relative path based on the path difference between `to`
        // and `from`
        for(i = fromStart + lastCommonSep + 1; i <= fromEnd; ++i)if (i === fromEnd || from.charCodeAt(i) === 47 /*/*/ ) {
            if (out.length === 0) out += '..';
            else out += '/..';
        }
        // Lastly, append the rest of the destination (`to`) path that comes after
        // the common path parts
        if (out.length > 0) return out + to.slice(toStart + lastCommonSep);
        else {
            toStart += lastCommonSep;
            if (to.charCodeAt(toStart) === 47 /*/*/ ) ++toStart;
            return to.slice(toStart);
        }
    },
    _makeLong: function _makeLong(path) {
        return path;
    },
    dirname: function dirname(path) {
        $3bfdb7183e8721d6$var$assertPath(path);
        if (path.length === 0) return '.';
        var code = path.charCodeAt(0);
        var hasRoot = code === 47 /*/*/ ;
        var end = -1;
        var matchedSlash = true;
        for(var i = path.length - 1; i >= 1; --i){
            code = path.charCodeAt(i);
            if (code === 47 /*/*/ ) {
                if (!matchedSlash) {
                    end = i;
                    break;
                }
            } else // We saw the first non-path separator
            matchedSlash = false;
        }
        if (end === -1) return hasRoot ? '/' : '.';
        if (hasRoot && end === 1) return '//';
        return path.slice(0, end);
    },
    basename: function basename(path, ext) {
        if (ext !== undefined && typeof ext !== 'string') throw new TypeError('"ext" argument must be a string');
        $3bfdb7183e8721d6$var$assertPath(path);
        var start = 0;
        var end = -1;
        var matchedSlash = true;
        var i;
        if (ext !== undefined && ext.length > 0 && ext.length <= path.length) {
            if (ext.length === path.length && ext === path) return '';
            var extIdx = ext.length - 1;
            var firstNonSlashEnd = -1;
            for(i = path.length - 1; i >= 0; --i){
                var code = path.charCodeAt(i);
                if (code === 47 /*/*/ ) // If we reached a path separator that was not part of a set of path
                // separators at the end of the string, stop now
                {
                    if (!matchedSlash) {
                        start = i + 1;
                        break;
                    }
                } else {
                    if (firstNonSlashEnd === -1) {
                        // We saw the first non-path separator, remember this index in case
                        // we need it if the extension ends up not matching
                        matchedSlash = false;
                        firstNonSlashEnd = i + 1;
                    }
                    if (extIdx >= 0) {
                        // Try to match the explicit extension
                        if (code === ext.charCodeAt(extIdx)) {
                            if (--extIdx === -1) // We matched the extension, so mark this as the end of our path
                            // component
                            end = i;
                        } else {
                            // Extension does not match, so our result is the entire path
                            // component
                            extIdx = -1;
                            end = firstNonSlashEnd;
                        }
                    }
                }
            }
            if (start === end) end = firstNonSlashEnd;
            else if (end === -1) end = path.length;
            return path.slice(start, end);
        } else {
            for(i = path.length - 1; i >= 0; --i){
                if (path.charCodeAt(i) === 47 /*/*/ ) // If we reached a path separator that was not part of a set of path
                // separators at the end of the string, stop now
                {
                    if (!matchedSlash) {
                        start = i + 1;
                        break;
                    }
                } else if (end === -1) {
                    // We saw the first non-path separator, mark this as the end of our
                    // path component
                    matchedSlash = false;
                    end = i + 1;
                }
            }
            if (end === -1) return '';
            return path.slice(start, end);
        }
    },
    extname: function extname(path) {
        $3bfdb7183e8721d6$var$assertPath(path);
        var startDot = -1;
        var startPart = 0;
        var end = -1;
        var matchedSlash = true;
        // Track the state of characters (if any) we see before our first dot and
        // after any path separator we find
        var preDotState = 0;
        for(var i = path.length - 1; i >= 0; --i){
            var code = path.charCodeAt(i);
            if (code === 47 /*/*/ ) {
                // If we reached a path separator that was not part of a set of path
                // separators at the end of the string, stop now
                if (!matchedSlash) {
                    startPart = i + 1;
                    break;
                }
                continue;
            }
            if (end === -1) {
                // We saw the first non-path separator, mark this as the end of our
                // extension
                matchedSlash = false;
                end = i + 1;
            }
            if (code === 46 /*.*/ ) {
                // If this is our first dot, mark it as the start of our extension
                if (startDot === -1) startDot = i;
                else if (preDotState !== 1) preDotState = 1;
            } else if (startDot !== -1) // We saw a non-dot and non-path separator before our dot, so we should
            // have a good chance at having a non-empty extension
            preDotState = -1;
        }
        if (startDot === -1 || end === -1 || // We saw a non-dot character immediately before the dot
        preDotState === 0 || // The (right-most) trimmed path component is exactly '..'
        preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) return '';
        return path.slice(startDot, end);
    },
    format: function format(pathObject) {
        if (pathObject === null || typeof pathObject !== 'object') throw new TypeError('The "pathObject" argument must be of type Object. Received type ' + typeof pathObject);
        return $3bfdb7183e8721d6$var$_format('/', pathObject);
    },
    parse: function parse(path) {
        $3bfdb7183e8721d6$var$assertPath(path);
        var ret = {
            root: '',
            dir: '',
            base: '',
            ext: '',
            name: ''
        };
        if (path.length === 0) return ret;
        var code = path.charCodeAt(0);
        var isAbsolute = code === 47 /*/*/ ;
        var start;
        if (isAbsolute) {
            ret.root = '/';
            start = 1;
        } else start = 0;
        var startDot = -1;
        var startPart = 0;
        var end = -1;
        var matchedSlash = true;
        var i = path.length - 1;
        // Track the state of characters (if any) we see before our first dot and
        // after any path separator we find
        var preDotState = 0;
        // Get non-dir info
        for(; i >= start; --i){
            code = path.charCodeAt(i);
            if (code === 47 /*/*/ ) {
                // If we reached a path separator that was not part of a set of path
                // separators at the end of the string, stop now
                if (!matchedSlash) {
                    startPart = i + 1;
                    break;
                }
                continue;
            }
            if (end === -1) {
                // We saw the first non-path separator, mark this as the end of our
                // extension
                matchedSlash = false;
                end = i + 1;
            }
            if (code === 46 /*.*/ ) {
                // If this is our first dot, mark it as the start of our extension
                if (startDot === -1) startDot = i;
                else if (preDotState !== 1) preDotState = 1;
            } else if (startDot !== -1) // We saw a non-dot and non-path separator before our dot, so we should
            // have a good chance at having a non-empty extension
            preDotState = -1;
        }
        if (startDot === -1 || end === -1 || // We saw a non-dot character immediately before the dot
        preDotState === 0 || // The (right-most) trimmed path component is exactly '..'
        preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) {
            if (end !== -1) {
                if (startPart === 0 && isAbsolute) ret.base = ret.name = path.slice(1, end);
                else ret.base = ret.name = path.slice(startPart, end);
            }
        } else {
            if (startPart === 0 && isAbsolute) {
                ret.name = path.slice(1, startDot);
                ret.base = path.slice(1, end);
            } else {
                ret.name = path.slice(startPart, startDot);
                ret.base = path.slice(startPart, end);
            }
            ret.ext = path.slice(startDot, end);
        }
        if (startPart > 0) ret.dir = path.slice(0, startPart - 1);
        else if (isAbsolute) ret.dir = '/';
        return ret;
    },
    sep: '/',
    delimiter: ':',
    win32: null,
    posix: null
};
$3bfdb7183e8721d6$var$posix.posix = $3bfdb7183e8721d6$var$posix;
module.exports = $3bfdb7183e8721d6$var$posix;

});
parcelRegister("hPtJY", function(module, exports) {
// shim for using process in browser
var $cfae44f0dfdf62c0$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $cfae44f0dfdf62c0$var$cachedSetTimeout;
var $cfae44f0dfdf62c0$var$cachedClearTimeout;
function $cfae44f0dfdf62c0$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $cfae44f0dfdf62c0$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        else $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        else $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    }
})();
function $cfae44f0dfdf62c0$var$runTimeout(fun) {
    if ($cfae44f0dfdf62c0$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedSetTimeout === $cfae44f0dfdf62c0$var$defaultSetTimout || !$cfae44f0dfdf62c0$var$cachedSetTimeout) && setTimeout) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $cfae44f0dfdf62c0$var$runClearTimeout(marker) {
    if ($cfae44f0dfdf62c0$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedClearTimeout === $cfae44f0dfdf62c0$var$defaultClearTimeout || !$cfae44f0dfdf62c0$var$cachedClearTimeout) && clearTimeout) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $cfae44f0dfdf62c0$var$queue = [];
var $cfae44f0dfdf62c0$var$draining = false;
var $cfae44f0dfdf62c0$var$currentQueue;
var $cfae44f0dfdf62c0$var$queueIndex = -1;
function $cfae44f0dfdf62c0$var$cleanUpNextTick() {
    if (!$cfae44f0dfdf62c0$var$draining || !$cfae44f0dfdf62c0$var$currentQueue) return;
    $cfae44f0dfdf62c0$var$draining = false;
    if ($cfae44f0dfdf62c0$var$currentQueue.length) $cfae44f0dfdf62c0$var$queue = $cfae44f0dfdf62c0$var$currentQueue.concat($cfae44f0dfdf62c0$var$queue);
    else $cfae44f0dfdf62c0$var$queueIndex = -1;
    if ($cfae44f0dfdf62c0$var$queue.length) $cfae44f0dfdf62c0$var$drainQueue();
}
function $cfae44f0dfdf62c0$var$drainQueue() {
    if ($cfae44f0dfdf62c0$var$draining) return;
    var timeout = $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$cleanUpNextTick);
    $cfae44f0dfdf62c0$var$draining = true;
    var len = $cfae44f0dfdf62c0$var$queue.length;
    while(len){
        $cfae44f0dfdf62c0$var$currentQueue = $cfae44f0dfdf62c0$var$queue;
        $cfae44f0dfdf62c0$var$queue = [];
        while(++$cfae44f0dfdf62c0$var$queueIndex < len)if ($cfae44f0dfdf62c0$var$currentQueue) $cfae44f0dfdf62c0$var$currentQueue[$cfae44f0dfdf62c0$var$queueIndex].run();
        $cfae44f0dfdf62c0$var$queueIndex = -1;
        len = $cfae44f0dfdf62c0$var$queue.length;
    }
    $cfae44f0dfdf62c0$var$currentQueue = null;
    $cfae44f0dfdf62c0$var$draining = false;
    $cfae44f0dfdf62c0$var$runClearTimeout(timeout);
}
$cfae44f0dfdf62c0$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $cfae44f0dfdf62c0$var$queue.push(new $cfae44f0dfdf62c0$var$Item(fun, args));
    if ($cfae44f0dfdf62c0$var$queue.length === 1 && !$cfae44f0dfdf62c0$var$draining) $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$drainQueue);
};
// v8 likes predictible objects
function $cfae44f0dfdf62c0$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$cfae44f0dfdf62c0$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$cfae44f0dfdf62c0$var$process.title = 'browser';
$cfae44f0dfdf62c0$var$process.browser = true;
$cfae44f0dfdf62c0$var$process.env = {};
$cfae44f0dfdf62c0$var$process.argv = [];
$cfae44f0dfdf62c0$var$process.version = ''; // empty string to avoid regexp issues
$cfae44f0dfdf62c0$var$process.versions = {};
function $cfae44f0dfdf62c0$var$noop() {}
$cfae44f0dfdf62c0$var$process.on = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.addListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.once = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.off = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeAllListeners = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.emit = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependOnceListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.listeners = function(name) {
    return [];
};
$cfae44f0dfdf62c0$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$cfae44f0dfdf62c0$var$process.cwd = function() {
    return '/';
};
$cfae44f0dfdf62c0$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$cfae44f0dfdf62c0$var$process.umask = function() {
    return 0;
};

});


parcelRegister("6tULh", function(module, exports) {

$parcel$export(module.exports, "prepareHTML", () => $4b817b2d0800a76b$export$4b629e674c7cd5f0);

var $6KOho = parcelRequire("6KOho");
function $4b817b2d0800a76b$export$4b629e674c7cd5f0() {
    const footerContent = '<div id="footer"></div>';
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))('body').append(footerContent);
}

});



//# sourceMappingURL=1_Program_Activation.dfa95b25.js.map
